import { HStack, Image, Text } from '@chakra-ui/react';
import { GAME_STATUS } from '../constants/game';
import { borders } from '../theme';
import stopIcon from '../assets/stopIcon.svg';
import { useSelector } from 'react-redux';
import { reselectGameMoneyConfig } from '../routes/reselectors';

const GameStopInfo = () => {
  const { gameStatus } = useSelector(reselectGameMoneyConfig);
  return (
    <>
      {gameStatus === GAME_STATUS.PENDING_STOP && (
        <HStack
          alignItems={'center'}
          spacing={2}
          py={4}
          px={5}
          bgColor={'c-109'}
          border={borders.normal}
          borderRadius={20}
          mt={-2}
        >
          <Image src={stopIcon} boxSize={6} alt="timer icon" />
          <Text color={'c-102'} fontSize={'md'}>
            The game will be stopped on the next hand
          </Text>
        </HStack>
      )}
    </>
  );
};

export default GameStopInfo;
